import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';

class AiScreenerPrompt extends DomainObject {
  text;
  totalCandidateCount;
  completedCandidateCount;
  paused;

  constructor(other) {
    super();

    makeObservable(this, {
      text: observable,
      totalCandidateCount: observable,
      completedCandidateCount: observable,
      paused: observable,
      inProgress: computed,
      progress: computed
    });

    this.merge(other);
  }

  get inProgress() {
    return this.completedCandidateCount !== this.totalCandidateCount && !this.paused;
  }

  get progress() {
    return `${this.completedCandidateCount}/${this.totalCandidateCount}`;
  }
}

export default AiScreenerPrompt;
